import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from '@src/store/base-query';

export const fastingPlansApi = createApi({
  reducerPath: 'fastingPlansApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getFastingPlans: builder.query({
      query: () => `fasting-plans`,
      providesTags: ['FastingPlans'],
    }),
    getFastingPlanById: builder.query({
      query: (id) => `fasting-plans/${id}`,
      providesTags: ['FastingPlans'],
    }),
    createFastingPlan: builder.mutation({
      query: (newFastingPlan) => ({
        url: `fasting-plans`,
        method: 'POST',
        body: newFastingPlan,
      }),
      invalidatesTags: ['FastingPlans'],
    }),
  }),
});

export const { useGetFastingPlansQuery, useGetFastingPlanByIdQuery, useCreateFastingPlanMutation } = fastingPlansApi;
